

 const apptheme = {
    primaryColor: '#1a4e3b',
    secondaryColor : '#FFFFFF',
    tertiaryColor : '#276946',
    quaternaryColor : '#ec9c05',
    quintenaryColor : '#44c485',
    senaryColor : '#339263',
    septenary : '#666666'

} 

export default apptheme
